// extracted by mini-css-extract-plugin
export default {"aboutme":"Aboutme_aboutme__va9J0","about":"Aboutme_about__CDcO0","Emoji":"Aboutme_Emoji__tFj05","floating":"Aboutme_floating__bXsPw"};